import React, { Fragment, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { clearAssetTrackers, fetchAssetTrackers, fetchMaintenanceHomebases, fetchVehicles, updateNotificationsOnTrackers } from '../../../../../state/actions/vehicles'
import { useAuth0 } from '@auth0/auth0-react'
import ReportPage from '../../../reportPage.v2'
import AssetStatusWidget from '../../assetTrackerStatusDetails/assetStatusWidget'
import { checkTrackersBatteryIssue, getCategoriesForDropdown } from '../../../../../utils/assets'
import TrackerDetailsModal from '../../modals/TrackerDetailsModal'
import { useNavigate , useLocation } from 'react-router-dom'
import ConfirmationModal from '../../modals/confirmationModal'
import { SimpleDropdown } from '@modul-connect/shared/components/atoms/dropdown/simpleDropdown'
import { GroupingOptionSelector } from '../../../tollPassages/summary/groupingOptionSelector'
import AssetTrackerTable from '../../assetTrackerStatusDetails/assetTrackerTable'
import AssetTrackerTableViewAll from '../../assetTrackerStatusDetails/assetTrackerTableViewAll'
import { fetchAssetCategories } from '../../../../../state/actions/assets'

export const groupingOptions = {
  byHomebase: 'Homebase',
  ViewAll: 'View all'
}

const actions = [
  'Turn off notifications',
  'Turn on notifications',
  'Delete'
]

const isStandardUser = (tags) => {
  if (tags?.some(t => t.privilege === 'admin' || t.privilege === 'super'))
    return false
  return true
}

const assetTrackerStatusPage = ({
  selected_organisations,
  fetchAssetTrackers,
  fetchAssetCategories,
  assets,
  loading,
  vehicles,
  fetchVehicles,
  fetchMaintenanceHomebases,
  clearAssetTrackers,
  updateNotificationsOnTrackers,
  disabled,
  maintenance_plans,
  subtrees,
  authenticated_user
}) => {
  useEffect(
    () => {
      clearAssetTrackers()
      getAccessTokenSilently().then((accessToken) => {
        fetchAssetCategories(accessToken)
      })
    },[])

  const navigate = useNavigate()
  function useQuery() {
    const { search } = useLocation()
  
    return React.useMemo(() => new URLSearchParams(search), [search])
  }

  const [openModal, setOpenModal] = useState(null) // stores the beaconID of selected beacon, otherwise null
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false) // stores the beaconID of selected beacon, otherwise null
  const [groupBy, setGroupBy] = useState( useQuery().get('groupby') ?? groupingOptions.byHomebase)
  const [action, setAction] = useState(null)
  const [edit, setEdit] = useState(false)
  const [categoryOption, setCategoryOption] = useState(null)
  const [filter, setFilter] = useState('')
  const [selectedTracker, setSelectedTracker] = useState(null)
  const [checkedRows, setCheckedRows] = useState([])

  const { getAccessTokenSilently } = useAuth0()

  useEffect(() =>{
    if(!edit)
      setSelectedTracker(null)
  }, [edit])

  useEffect(() =>{
    getAccessTokenSilently().then((accessToken) => {
      if(checkedRows.length > 0 )
        switch (action) {
          case 'Turn on notifications':
            setOpenConfirmationModal(true)
            return
          case 'Turn off notifications':
            setOpenConfirmationModal(true)
            return
          case 'Delete':
            console.error('Delete', checkedRows)
            return
          default: 
            return
        }
    })
  },[action,selected_organisations])

  useEffect(()=>
  {
    if (checkedRows?.includes(selectedTracker?.[0]?.beaconId))
    {
      checkedRows.pop(selectedTracker?.[0]?.beaconId)
      setCheckedRows(checkedRows)
    }
    else
    {
      if(selectedTracker)
      {
        checkedRows.push(selectedTracker?.[0]?.beaconId)
        setCheckedRows(checkedRows)
      }
    }
  }, [selectedTracker])


  useEffect(() => {
    setFilter('')
    setCategoryOption(null)
    setEdit(false)
    getAccessTokenSilently().then((accessToken) => {
      fetchAssetTrackers(accessToken, groupBy === groupingOptions.byHomebase)
    })
  }, [groupBy, selected_organisations])

  useEffect(() => {
    getAccessTokenSilently().then((accessToken) => {
      fetchVehicles(accessToken)
      fetchMaintenanceHomebases(accessToken)
    })
  }, [selected_organisations])


  const changeGroupBy = (group) => {
    clearAssetTrackers()
    setGroupBy(group)
    navigate({ search: '?groupby=' + group }, { replace: true })
  }

  const handleConfirmation = () => {
    getAccessTokenSilently().then((accessToken) => {
      if(checkedRows.length > 0 )
        switch (action) {
          case 'Turn on notifications':
            updateNotificationsOnTrackers(accessToken, checkedRows, true)
            setOpenConfirmationModal(false)
            setEdit(false)
            setAction('None')
            return
          case 'Turn off notifications':
            updateNotificationsOnTrackers(accessToken, checkedRows, false)
            setOpenConfirmationModal(false)
            setEdit(false)
            setAction('None')
            return
          case 'Delete':
            setOpenConfirmationModal(false)
            setEdit(false)
            setAction('None')
            return
          default: 
            return
        }
    })
  }

  const allAssets = []
  if(groupBy === groupingOptions.byHomebase )
    assets.forEach(vehicle => 
      vehicle?.assets?.map(asset => 
        allAssets.push({
          asset: { ...asset, homebaseId: vehicle.vin }, // TODO: In the future, the backend should return this, need an endpoint that uses the new asset/tracker/homebase structure we have
          vehicleName: vehicle.vehicleName,
          boxId: vehicle?.mainbox?.boxId,
          organisationId: vehicle?.organisationId
        })))
  else
    assets.forEach(asset => {
      allAssets.push({
        asset: { ...asset, homebaseId: asset?.vehicle?.vin },
        vehicleName: asset?.vehicle?.vehicleName,
        boxId: asset?.vehicle?.mainbox?.boxId,
        organisationId: asset?.vehicle?.organisationId
      })
    })
        
  const configuredAssets = allAssets.length
  let missingAssets = 0
  if(groupBy === groupingOptions.byHomebase )
    assets.forEach(vehicle => {
      missingAssets += vehicle?.assets?.filter(asset => !asset?.isInside)?.length ?? 0
    })
  else
    assets.forEach(asset =>  !asset?.isInside ?  missingAssets+= 1: missingAssets+= 0)

  let batteryIssueAssets = 0
  if(groupBy === groupingOptions.byHomebase)
    assets.forEach(vehicle => {
      batteryIssueAssets += vehicle?.assets?.filter(asset => checkTrackersBatteryIssue(asset?.tracker?.currentStatus?.batteryLevel))?.length ?? 0
    })
  else
    assets.forEach(asset =>  checkTrackersBatteryIssue(asset?.tracker?.currentStatus?.batteryLevel) ? batteryIssueAssets += 1  :  batteryIssueAssets +=  0 )

  const selectedAsset = allAssets.find(asset => asset?.asset?.tracker?.beaconId === openModal)
  
  const selectedAssetIsProtected = selectedAsset 
    ? subtrees.subtrees.find(o => o.uuid === selectedAsset?.organisationId)?.services.includes('Protected Assets') && isStandardUser(authenticated_user?.tags)
    : true

  let prepared_vehicles = []
  //TODO: FIX THE ISSUE WITH SERVER NOT SENDING ALL VEHICLES DATA
  /* vehicles.map(vehicle => {
    prepared_vehicles.push({
      boxId: vehicle.boxId,
      vehicleName: vehicle.vehicleName,
      telematicsId: vehicle.telematicsId
    })
  }) */

  const dataIsGroupedByVehicle = assets?.length && assets[0]?.mainbox

  prepared_vehicles = vehicles?.map(v => {return {
    boxId: v.boxId,
    vehicleName: v.name,
    telematicsId: v.telematicsId,
    vin: v.vehicle?.vin
  }})  
  /* <View 
      style= 
      {{
        display: 'flex', 
        flexDirection: 'row', 
        borderTop: '.5px solid #D5D5D5', 
        borderBottom: '.5px solid #D5D5D5', 
        backgroundColor: theme.colors.tableBackground1,
        gap: 1
      }}>
      <View>
        <SimpleButton 
          text={'Edit'}
          icon={edit ? CancelEditIcon : EditIcon}
          onClick={() => setEdit(!edit)}
          disabled={loading.fetchAssetTrackers === "loading" && loading.fetchAssetTrackers !== "failed"}
        />
      </View>

      <View>
        <SimpleDropdown 
          addOptionNone
          options={actions} 
          selectedValue={[action]}
          setValue={setAction}
          renderDefaultValue={'Actions'}
          extendInput=
            {{
              backgroundColor: theme.colors.simpleButtonBackground, 
              borderRadius: "0px",
              width: '95%',
              padding: 0,
              paddingLeft: '20px',
              paddingRight: '120px',
              paddingTop: '10px',
              paddingBottom: '10px',
              textTransform: 'none',
              fontFamily: 'Inter',
              fontStyle: 'normal',
              fontWeight: 400,
              fontSize: '16px',
              lineHeight: '19px'
            }}
        /> 
      </View>
    </View> */

  const isLoading = (loading.fetchAssetTrackers === 'loading') || (loading.counter_fetchingTrackersAddresses > 0)

  const viewSelector = <GroupingOptionSelector
    onChange={(selection) => {
      changeGroupBy(selection)
    }}
    options={groupingOptions}
    value={groupBy}
    disabled={loading.fetchAssetTrackers === 'loading'}
  />

  if (groupBy === groupingOptions.byHomebase) {
    const tables = <AssetTrackerTable
      setOpenModal={setOpenModal}
      searchFilter={filter}
    />
    return (
      <Fragment>
        <ReportPage
          useOldDatePickers
          disabled={disabled}
          noPadding
          noBackground
          noTimePickerBar
          onSearchChange={setFilter}
          groupingOptionSelector={viewSelector}
          searchValue={filter}
          kpi={<AssetStatusWidget
            isLoading={isLoading}
            configuredAssets={configuredAssets}
            missingAssets={missingAssets}
            batteryIssueAssets={batteryIssueAssets}
          />}
          title={'Asset Trackers'}
          noDataMessage={'There are no asset trackers.'}
          tables={assets?.length ? tables : []}
          isLoading={isLoading}
          fetchingDataFailed={loading.fetchAssetTrackers === 'failed'}
        >
        </ReportPage>
        <TrackerDetailsModal
          openModal={openModal}
          onClose={() => setOpenModal(null)}
          beacon={selectedAsset}
          vehicles={prepared_vehicles}
          groupBy={groupBy}
          assetIsProtected={selectedAssetIsProtected}
        />
      </Fragment>
    )
  }
  else {
    const tables = <AssetTrackerTableViewAll
      setOpenModal={setOpenModal} 
      searchFilter={filter} 
      filterOption={categoryOption}
      filterAppliesToColumnIndex={3}
      setSelectedTracker={setSelectedTracker}
      selectedTracker={selectedTracker}
      edit={edit}
    />
    return (
      <Fragment>
        <ReportPage
          useOldDatePickers
          disabled={disabled}
          noPadding
          noBackground
          noTimePickerBar
          onSearchChange={setFilter}
          title={'Asset Trackers'}
          noDataMessage={'There are no asset trackers.'}
          groupingOptionSelector={viewSelector}
          filterDropdowns={[<SimpleDropdown 
            disabled={loading.fetchAssetTrackers === 'loading'}
            flexWidth
            addOptionNone
            options={getCategoriesForDropdown().map(category => category.name)} 
            selectedValue={[categoryOption]}
            setValue={setCategoryOption}
            renderDefaultValue={'Category'}
          /> ]}
          tables={assets?.length ? tables : []}
          isLoading={isLoading}
          fetchingDataFailed={loading.fetchAssetTrackers === 'failed'}
          extend={{ paddingTop: 0 }}
          headerSection={
            <AssetStatusWidget
              configuredAssets={configuredAssets}
              missingAssets={missingAssets}
              batteryIssueAssets={batteryIssueAssets}
              groupBy={groupBy}
            />
          }
        >
        </ReportPage>
        <TrackerDetailsModal
          openModal={openModal}
          onClose={() => setOpenModal(null)}
          beacon={selectedAsset}
          vehicles={prepared_vehicles}
          groupBy={groupBy}
          assetIsProtected={selectedAssetIsProtected}
        />
        <ConfirmationModal 
          open = {openConfirmationModal}
          onClose={() => setOpenConfirmationModal(false)}
          body={
            checkedRows.length > 1
              ? 'You\'re about to '  + action + ' for ' + checkedRows.length + ' Asset Trackers.'
              : 'You\'re about to '  + action + ' for ' + checkedRows.length + ' Asset Tracker.'
          }
          onConfirm={() => handleConfirmation()}
          title = {'Are you sure?'}
        />
      </Fragment>
    )
  }
}

const mapStateToProps = (props) => props

const mapDispatchToProps = (dispatch) => ({
  fetchAssetTrackers: (accessToken, byVehicle) => dispatch(fetchAssetTrackers(accessToken, byVehicle)),
  fetchAssetCategories: (accessToken) => dispatch(fetchAssetCategories(accessToken)),
  fetchVehicles: (accessToken) => dispatch(fetchVehicles(accessToken)),
  fetchMaintenanceHomebases: (accessToken) => dispatch(fetchMaintenanceHomebases(accessToken)),
  clearAssetTrackers: () => dispatch(clearAssetTrackers()),
  updateNotificationsOnTrackers: (accessToken, trackers, isEnabled) => dispatch(updateNotificationsOnTrackers(accessToken, trackers, isEnabled))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(assetTrackerStatusPage)
